import { DeviceModel } from 'commons/src/constants';
import { DeviceSensorDetailsType, CurrentSensorValuesType, RadonValues } from '../models/commons';
import { EmptyAction } from './index';

export enum DeviceActionType {
    FetchDeviceDataInit = 'FETCH_PUBLIC_DEVICE_DATA/INIT',
    FetchDeviceDataSuccess = 'FETCH_PUBLIC_DEVICE_DATA/SUCCESS',
    FetchDeviceDataError = 'FETCH_PUBLIC_DEVICE_DATA/ERROR',
    FetchDeviceSensorDataInit = 'FETCH_PUBLIC_DEVICE_SENSOR_DATA/INIT',
    FetchDeviceSensorDataSuccess = 'FETCH_PUBLIC_DEVICE_SENSOR_DATA/SUCCESS',
    FetchDeviceSensorDataError = 'FETCH_PUBLIC_DEVICE_SENSOR_DATA/ERROR',
    FetchRadonDataInit = 'FETCH_PUBLIC_RADON_DATA/INIT',
    FetchRadonDataSuccess = 'FETCH_PUBLIC_RADON_DATA/SUCCESS',
    FetchRadonDataError = 'FETCH_PUBLIC_RADON_DATA/ERROR',
}

export type FetchPublicDeviceDataType = {
    publicUrlPath: string;
    measurementSystem: string;
    showAllSensors: boolean;
    backgroundColor?: string;
    isTest?: boolean;
};

export interface FetchPublicDeviceData {
    type: DeviceActionType.FetchDeviceDataInit;
    payload: FetchPublicDeviceDataType;
}

export const fetchPublicDeviceData = (payload: FetchPublicDeviceDataType): FetchPublicDeviceData => ({
    type: DeviceActionType.FetchDeviceDataInit as DeviceActionType.FetchDeviceDataInit,
    payload,
});

export interface FetchPublicRadonData {
    type: DeviceActionType.FetchRadonDataInit;
    payload: FetchPublicRadonDataType;
}
export const fetchPublicRadonData = (payload: FetchPublicRadonDataType): FetchPublicRadonData => ({
    type: DeviceActionType.FetchRadonDataInit as DeviceActionType.FetchRadonDataInit,
    payload,
});

export type FetchPublicDeviceResponse = {
    deviceType: DeviceModel;
    organizationName?: string;
    organizationLogo?: string;
    segmentName?: string;
    sensorDetails: { [sensor: string]: DeviceSensorDetailsType };
    serialNumber?: string;
};

export interface FetchPublicDeviceDataSuccess {
    type: DeviceActionType.FetchDeviceDataSuccess;
    response: FetchPublicDeviceResponse;
}
export const fetchPublicDeviceDataSuccess = (response: FetchPublicDeviceResponse): FetchPublicDeviceDataSuccess => ({
    type: DeviceActionType.FetchDeviceDataSuccess as DeviceActionType.FetchDeviceDataSuccess,
    response,
});

export interface FetchPublicDeviceDataError {
    type: DeviceActionType.FetchDeviceDataError;
    error: string;
}
export const fetchPublicDeviceDataError = (error: string): FetchPublicDeviceDataError => ({
    type: DeviceActionType.FetchDeviceDataError as DeviceActionType.FetchDeviceDataError,
    error,
});

export interface FetchPublicDeviceSensorData {
    type: DeviceActionType.FetchDeviceSensorDataInit;
    payload: FetchPublicDeviceDataType;
}
export const fetchPublicDeviceSensorData = (payload: FetchPublicDeviceDataType): FetchPublicDeviceSensorData => ({
    type: DeviceActionType.FetchDeviceSensorDataInit as DeviceActionType.FetchDeviceSensorDataInit,
    payload,
});

export type FetchPublicDeviceSensorResponse = {
    sensorData: Array<CurrentSensorValuesType>;
    timeStamp: number;
};

export interface FetchPublicDeviceSensorDataSuccess {
    type: DeviceActionType.FetchDeviceSensorDataSuccess;
    response: FetchPublicDeviceSensorResponse;
}
export const fetchPublicDeviceSensorDataSuccess = (
    response: FetchPublicDeviceSensorResponse
): FetchPublicDeviceSensorDataSuccess => ({
    type: DeviceActionType.FetchDeviceSensorDataSuccess as DeviceActionType.FetchDeviceSensorDataSuccess,
    response,
});
export interface FetchPublicDeviceSensorDataError {
    type: DeviceActionType.FetchDeviceSensorDataError;
    error: string;
}
export const fetchPublicDeviceSensorDataError = (error: string): FetchPublicDeviceSensorDataError => ({
    type: DeviceActionType.FetchDeviceSensorDataError as DeviceActionType.FetchDeviceSensorDataError,
    error,
});

export type FetchPublicRadonDataType = { geoHash: string };

export interface FetchPublicRadonDataSuccess {
    type: DeviceActionType.FetchRadonDataSuccess;
    response: FetchPublicRadonResponse;
}

// eslint-disable-next-line camelcase
export type FetchPublicRadonResponse = { radon_unit: string; time_series: RadonValues[] };

export const fetchPublicRadonDataSuccess = (response: FetchPublicRadonResponse): FetchPublicRadonDataSuccess => ({
    type: DeviceActionType.FetchRadonDataSuccess as DeviceActionType.FetchRadonDataSuccess,
    response,
});

export interface FetchPublicRadonDataError {
    type: DeviceActionType.FetchRadonDataError;
    error: string;
}
export const fetchPublicRadonDataError = (error: string): FetchPublicRadonDataError => ({
    type: DeviceActionType.FetchRadonDataError as DeviceActionType.FetchRadonDataError,
    error,
});

export type PublicDeviceAction =
    | FetchPublicDeviceData
    | FetchPublicDeviceDataSuccess
    | FetchPublicDeviceDataError
    | FetchPublicDeviceSensorData
    | FetchPublicDeviceSensorDataSuccess
    | FetchPublicDeviceSensorDataError
    | FetchPublicRadonData
    | FetchPublicRadonDataSuccess
    | FetchPublicRadonDataError
    | EmptyAction;
